Object.defineProperty(exports, "__esModule", { value: true })

exports.default = __webpack_require__.stylable.create(
  "root",
  "AboutPage122033720",
  {"root":"AboutPage122033720--root","bigColumn":"AboutPage122033720--bigColumn","gap":"AboutPage122033720--gap","smallColumn":"AboutPage122033720--smallColumn"},
  "",
  13,
  "AboutPage122033720"
);

